import { SEPARATOR } from '@/finsight/ui/common/components/header/Header/constants';
import { IgetFiltersByPairs } from './types';

type TbuildUUIDPairs = Pick<IgetFiltersByPairs, 'selectedProducts' | 'selectedRegions'>;

export const buildUUIDPairs = ({ selectedProducts, selectedRegions }: TbuildUUIDPairs): string[] => {
  const pairs = [];
  selectedProducts.forEach((productId) => {
    selectedRegions.forEach((regionId) => {
      pairs.push(productId + SEPARATOR + regionId);
    });
  });

  return pairs;
};
